const initState={
   athleteSummary:[]
}

const resetAthleteSummaryReducer = (state=initState, action) => {
 switch(action.type){
    case "GET_ATHLETE_SUMMARY":
        return{
            ...state,
            athleteSummary:action.payload
        }
        default:
      return {
        ...state,
      };

 }
}

export default resetAthleteSummaryReducer
